import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes, faImage, faUpload } from '@fortawesome/free-solid-svg-icons';
import baseURL from '../../url';

export default function NewBanner({ onCreated }) {
  const [isOpen, setIsOpen] = useState(false);
  const [imagenFile, setImagenFile] = useState(null);
  const [imagenPreview, setImagenPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  // Toasts con clases globales
  const [toasts, setToasts] = useState([]);
  const showToast = (message, type = 'info') => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 3800);
  };

  const openModal = () => {
    resetForm();
    setIsOpen(true);
  };

  const closeModal = () => setIsOpen(false);

  const resetForm = () => {
    setImagenFile(null);
    if (imagenPreview) URL.revokeObjectURL(imagenPreview);
    setImagenPreview(null);
  };

  const handleImagenChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (imagenPreview) URL.revokeObjectURL(imagenPreview);
    setImagenFile(file);
    setImagenPreview(URL.createObjectURL(file));
  };

  const crear = async () => {
    if (!imagenFile) {
      showToast('Por favor, selecciona una imagen.', 'warning');
      return;
    }
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('imagen', imagenFile);

      const res = await fetch(`${baseURL}/bannersPost.php`, {
        method: 'POST',
        body: formData,
      });

      const data = await res.json();
      if (data?.mensaje) {
        showToast('Banner creado correctamente', 'success');
        if (typeof onCreated === 'function') onCreated();
        closeModal();
      } else {
        showToast(data?.error || 'No se pudo crear el banner', 'error');
      }
    } catch (e) {
      console.error('Error:', e);
      showToast('Error de conexión. Inténtalo de nuevo.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Toasts globales */}
      {toasts.length > 0 && (
        <div className="product-toast-container">
          {toasts.map(t => (
            <div key={t.id} className={`product-toast ${t.type}`}>
              <div className="toast-icon">
                {t.type === 'success' && '✅'}
                {t.type === 'error' && '❌'}
                {t.type === 'warning' && '⚠️'}
                {t.type === 'info' && 'ℹ️'}
              </div>
              <div className="toast-content">
                <div className="toast-title">{t.message}</div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Botón para abrir modal */}
      <button onClick={openModal} className="btn-product-primary flex-center">
        <FontAwesomeIcon icon={faPlus} />
        Agregar
      </button>

      {/* Modal */}
      {isOpen && (
        <div className="product-modal-backdrop">
          <div className="product-modal-container" style={{ maxWidth: 720 }}>
            <div className="product-modal-header">
              <div className="product-modal-title">
                <FontAwesomeIcon icon={faImage} />
                Nuevo banner
              </div>
              <button className="product-close-button" onClick={closeModal}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>

            <div className="product-modal-body">
              <div className="product-section-card">
                <div className="product-section-header">
                  <div className="product-section-title">
                    <FontAwesomeIcon icon={faUpload} />
                    Imagen
                  </div>
                </div>

                <div className="product-section-content">
                  <div className="product-images-grid">
                    <label
                      htmlFor="banner-file"
                      className={`product-image-upload-area ${imagenPreview ? 'has-image' : ''}`}
                      style={{ cursor: 'pointer' }}
                      title={imagenPreview ? 'Cambiar imagen' : 'Subir imagen'}
                    >
                      {imagenPreview ? (
                        <img src={imagenPreview} alt="Vista previa" className="product-image-preview" />
                      ) : (
                        <div className="product-upload-content">
                          <div className="product-upload-icon">
                            <FontAwesomeIcon icon={faUpload} />
                          </div>
                          <div>Haz clic para seleccionar una imagen</div>
                        </div>
                      )}
                      <input
                        id="banner-file"
                        type="file"
                        accept="image/*"
                        onChange={handleImagenChange}
                        style={{ display: 'none' }}
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className="product-submit-section">
              <button className="btn-product-secondary" onClick={closeModal} disabled={loading}>
                Cancelar
              </button>
              <button
                className="btn-product-primary"
                onClick={crear}
                disabled={loading || !imagenFile}
              >
                {loading ? 'Procesando…' : 'Agregar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
